/* eslint-disable */
window.filter = {
  selects: [ // 'id' should match the attribute of the same name in the markup and 'key' specifies the key portion of the key/value pair in the query string
    { id: 'restrict_month', key: 'month' },
    { id: 'restrict_year', key: 'year' },
    { id: 'issues-list', key: 'rid' },
    { id: 'sponsored', key: 'sponsored' },
    { id: 'filter-select-sponsored', key: 'sponsored' },
    { id: 'session_select', key: 'c' },
    { id: 'filter-select-congress', key: 'c' },
    { id: 'inline-search-congress', key: 'c' }, // these apparently exist as an alternate to session_select
    { id: 'county-restrict', key: 'county' },
    { id: 'region-restrict', key: 'region' },
    { id: 'type-restrict', key: 'type' },
    { id: 'maxrows', key: 'maxrows' },
    { id: 'mode', key: 'mode' },
    { id: 'files-select', key: 'type' },
    { id: 'section', key: 'section' },
    { id: 'keyword', key: 'keyword' }
  ],

  query: null,
  sortcol: null,
  sortdir: null,
  sort: null,
  sourcepage: null, //added this so we can check if the parent window already has a query string.
  parent: null, // used to determine which inputs to look at - ones in the modal or ones in the sidebar
  /* checks to see if a value exists or is 0 */
  exists: function (obj) {
    return !!(obj || obj === 0);
  },

  /* utility function to get query parameters */
  getparam: function (param) {
    var value = null;
    if (this.exists(window.location.search)) {
      var params = {};
      var query = window.location.search.substr(1, window.location.search.length); // strip out the '?'
      var query_array = query.split('&');
      for (var x = 0; x < query_array.length; x++) {
        var temp = query_array[x].split('=');
        params[temp[0]] = temp[1];
      }
      if (this.exists(params[param])) { value = params[param]; }
    }
    return value;
  },

  clean: function (val) { // strips out potential xss reflection stuff
    val = val.replace(/<[^>]*?>/g, ''); // strip markup
    val = val.replace(/[<>'"\/\\()]+/g, ''); // markup fragments, quotes, slashes, parens

    return val;
  },

  evaluate: function (member) {
    var select;
    if (typeof this.parent !== 'undefined' && this.parent) {
      select = this.parent.querySelector('#' + member.id);
    } else {
      select = document.getElementById(member.id);
    }
    var val = '';

    if (this.exists(select)) {
      if (typeof (select) == 'select') {
        val = select.options[select.options.selectedIndex].value;
      } else { // input type='text', textarea, whatevs!
        val = select.value;
      }

      if (val != '' && val != 0) { this.query.push({ 'key': member.key, 'val': this.clean(val) }); }
    }
  },

  construct_query: function () {
    var q = '';
    var sourceHasQuery = this.sourcepage.indexOf('?');

    for (var x = 0; x < this.query.length; x++) {
      (q == '') && sourceHasQuery == -1 ? q += '?' : q += '&';
      q += this.query[x].key + '=' + encodeURIComponent(this.query[x].val);
    }

    if (this.exists(this.sortcol) && this.exists(this.sortdir)) {
      (q == '') ? q += '?' : q += '&';
      q += 'sort=' + encodeURIComponent(this.sortcol) + '&order=' + encodeURIComponent(this.sortdir);
    }

    return q;
  },

  run: function (page, event) {
    $(event.target).closest('form').submit(function (e) {
      e.preventDefault();
    });

    this.query = [];
    this.sourcepage = page;

    if (typeof event !== 'undefined') {
      this.parent = event.target.closest('.js-filter-container');
    }

    for (var x = 0; x < this.selects.length; x++) {
      this.evaluate(this.selects[x]);
    }
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }

    var newUrl;
    if (this.exists(page) && page != '') {
      newUrl = page + this.construct_query();
    } else {
      newUrl = document.location.origin + '/' + document.location.pathname + this.construct_query();
    }

    if (typeof transitions !== 'undefined' && newUrl) {
      transitions.go(newUrl);
    } else if (newUrl) {
      location.href = newUrl;
    }
  }
};
